import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { getHomepagePageUserData as getHomepagePageUserDataBase } from './api';

export type HomepagePageUserData = Awaited<ReturnType<typeof getHomepagePageUserDataBase>>;

export async function getHomepagePageUserData(utilityContext: UtilityContext): Promise<HomepagePageUserData> {
	const apiData = await getHomepagePageUserDataBase(utilityContext);

	return apiData;
}
